<template>
  <v-menu offset-y min-width="200">
    <template v-slot:activator="{ on }">
      <v-btn flat v-on="on" :loading="isLoading"><span class="text-capitalize">{{user.fname}}</span>
        <v-icon size="16">expand_more</v-icon>
        <v-avatar
            class="ml-2"
            size="48"
            color="grey darken-4"
        >
          <img v-if="user.photo" :src="user.photo" alt="avatar">
          <v-btn v-else icon disabled>
            <v-icon>account_circle</v-icon>
          </v-btn>
        </v-avatar>
      </v-btn>
    </template>
    <v-list>

      <v-list-tile @click="$router.push({name: 'editProfile'})">
        <v-list-tile-action>
          <v-icon>settings</v-icon>
        </v-list-tile-action>
        <v-list-tile-title>Edit Profile</v-list-tile-title>
      </v-list-tile>
      <v-list-tile
          v-if="user.auth === 'admin' || user.auth === 'superuser'"
          @click="$router.push({name: adminLink.name})"
      >
        <v-list-tile-action>
          <v-icon>{{ adminLink.i }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-title class="text-capitalize">{{ adminLink.name }}</v-list-tile-title>
      </v-list-tile>
      <v-list-tile @click="signout">
        <v-list-tile-action>
          <v-icon>exit_to_app</v-icon>
        </v-list-tile-action>
        <v-list-tile-title>Sign Out</v-list-tile-title>
      </v-list-tile>

    </v-list>
  </v-menu>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "UserMenu",
        computed: {
            ...mapGetters('auth', { user: 'getUserInfo'}),
            ...mapGetters('auth', ['isSuccess', 'isLoading']),
            adminLink() {
                return this.$route.path.startsWith('/admin') ? {
                    name: 'home',
                    i: 'home'
                } : {
                    name: 'admin',
                    i: 'verified_user'
                }
            }
        },
        methods: {
            signout() {
                this.$store.dispatch('auth/signout')
                    .then(() => {
                          this.$router.push('/')
                    })
            }
        }
    }
</script>

<style scoped>

</style>
